import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=487ff8fe"
import script from "./footerNav.vue?vue&type=script&lang=js"
export * from "./footerNav.vue?vue&type=script&lang=js"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=487ff8fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports